import { TransferRequestPayload, TransferResponse } from'./types';

export const createTransferRequest = async (data: TransferRequestPayload): Promise<TransferResponse> => {
 return new Promise((resolve) => {
 setTimeout(() => {
  resolve({ id:'TRN-'+ Math.floor(Math.random() * 1000), status:'Pending'});
 }, 1000);
 });
};

import { cxApiClient } from "@shared/api/clients/apiClientFactory";
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { ConsumerMetaTransferParams, ConsumerMetaTransferResponse } from "./types";

export const getConsumerMetaTransfer = async (params: ConsumerMetaTransferParams): Promise<ConsumerMetaTransferResponse> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "consumerWeb",
    "consumer-meta-transfer",
    (query) => {
      if (params.consumer_id) query.push("consumer_id", params.consumer_id.toString());
      if (params.remote_utility_id) query.push("remote_utility_id", params.remote_utility_id.toString());
      return query;
    }
  );

  const response = await cxApiClient.get(url);
  return response.data.result;
};
